import type { PropsWithChildren } from 'react'

import { WelcomeMessagesQueryProvider } from '@/modules/creator-settings/welcome-messages/query/welcome-message-query'
import { DefaultWelcomeMessageFetchProvider } from '@/modules/creator-settings/welcome-messages/service/welcome-message-fetch-context'
import { MessageMediaQueryProvider } from '@/modules/message/query/message-media-query-context'
import { DefaultMessageMediaProvider } from '@/modules/message/service/message-fetch-context'

export const WelcomeMessagesModule = ({ children }: PropsWithChildren) => {
  return (
    <DefaultWelcomeMessageFetchProvider>
      <DefaultMessageMediaProvider>
        <MessageMediaQueryProvider>
          <WelcomeMessagesQueryProvider>
            {children}
          </WelcomeMessagesQueryProvider>
        </MessageMediaQueryProvider>
      </DefaultMessageMediaProvider>
    </DefaultWelcomeMessageFetchProvider>
  )
}
